export default __webpack_public_path__ + "static/TPLOpostop-f49389b07886ee5d0304b5ddabee4652.png";